import type { StoreBlockEventSuccessResponse } from "@sperrdatei/dto/types";

type AddNumberResultProps = {
  result: StoreBlockEventSuccessResponse;
};

export const AddNumberResult: React.FC<AddNumberResultProps> = ({
  result,
}: AddNumberResultProps) => {
  return (
    <>
      <h6>Speichern abgeschlossen</h6>
      <p>
        <strong>Ergebnis</strong>: <br />
        {result.inserted > 0 ? (
          <span>
            Insgesamt {result.inserted > 1 ? "wurden" : "wurde"}{" "}
            <strong>{result.inserted}</strong> neue{" "}
            {result.inserted > 1 ? "Nummern" : "Nummer"} gesperrt.
            <br />
          </span>
        ) : (
          <span>
            Es wurde <strong>keine</strong> neue Nummer zur Sperrdatei
            hinzugefügt.
            <br />
          </span>
        )}
        {result.updated > 0 ? (
          <span>
            <strong>{result.updated}</strong>{" "}
            {result.updated > 1 ? "Nummern waren" : "Nummer war"} bereits in der
            Sperrdatei enthalten und wurde aktualisiert.
          </span>
        ) : (
          <span>
            Keine der gesperrten Nummern war bereits in der Sperrdatei
            enthalten.
          </span>
        )}
      </p>
    </>
  );
};
